// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lato', 'Lato Fallback'","fontWeight":400},"className":"__className_30554c","variable":"__variable_30554c"};